/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, shape, string, arrayOf, array, func, bool, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Media from 'react-media';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import GraphqlModal from './Partials/GraphqlModal';
import { addToCartDataType } from '../common/types';

const styles = (theme) => ({
    addonsProductContent: {
        color: theme.palette.black,
        paddingTop: '15px',
    },
    card: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '10px 0px 10px 0px',
        border: `1px solid ${theme.palette.grey8}`,
        '& .MuiCardContent-root': {
            padding: '10px',
            display: 'contents',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                minWidth: '100%',
            },
        },
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        flexFlow: 'row wrap',
        alignContent: 'flex-end',
        padding: '0 12px',
    },
    cardHeading: {
        fontSize: '18px',
        fontWeight: '600',
        color: theme.palette.colorCardContent,
    },
    cardHeadingMobile: {
        fontSize: '12px',
        fontWeight: '600',
        color: theme.palette.colorCardContent,
    },
    imageContainer: {
        width: 'auto',
    },
    image: {
        float: 'left',
        width: '5.2vw',
        maxWidth: '80px',
        margin: '5px 6px 5px 0px',
    },
    cardInfoMobile: {
        fontSize: '12px',
        color: theme.palette.colorCardContent,
        margin: 0,
    },
    cardInfo: {
        fontSize: '15px',
        color: theme.palette.colorCardContent,
        margin: 0,
        float: 'left',
    },
    cardImg: {
        flex: '1 0 0',
        maxWidth: '112px',
        paddingRight: '12px',
    },
    cardDesc: {
        margin: '5px',
        maxWidth: '220px',
        minWidth: '194px',
        [theme.breakpoints.up('md')]: {
            margin: '0 auto',
        },
    },
    options: {
        fontSize: '13px',
        fontWeight: '700',
        textDecoration: 'underline',
        letterSpacing: '1px',
        textAlign: 'center',
        margin: 0,
        width: '35%',
        maxWidth: '130px',
        cursor: 'pointer',
        [theme.breakpoints.up('md')]: {
            width: 'auto',
            marginLeft: 'auto',
        },
    },
    addonList: {
        width: '644px',
        height: 'auto',
        marginTop: 15,
        marginBottom: 16,
        position: 'relative',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.black,
    },
    listHeader: {
        padding: '4px 14px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    listTitle: {
        fontSize: 18,
        fontWeight: 600,
    },
    listItems: {
        width: '100%',
        display: 'flex',
        height: 30,
        padding: '0 6px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    deleteIcon: {
        display: 'flex',
        alignItems: 'center',
    },
    price: {
        marginLeft: 35,
    },
    cardDetail: {
        width: '100%',
        padding: '15px',
    },
    mobileImage: {
        maxWidth: 140,
    },
    imageMobile: {
        width: 50,
        '&:last-child': {
            display: 'none',
        },
    },
    imageMobileSingle: {
        width: 100,
    },
    imageMobileDouble: {
        width: 50,
    },
    mobileDescription: {
        display: 'inline-block',
    },
    mobileAddonBox: {
        padding: 5,
    },
    mobileDescArrow: {
        width: '10%',
        display: 'inline-block',
        verticalAlign: 'super',
    },
    mobileDesc: {
        width: '90%',
        display: 'inline-block',
    },
    middle: {
        verticalAlign: 'middle',
    },
});

class GraphqlAddon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            addonList: [],
        };
    }

    openModal = () => {
        this.setState({ openModal: true });
    }

    closeModal = () => {
        this.setState({ openModal: false });
    }

    /*
    * @description This will add addon item to state
    * @param {object} addon
    *
    */

    addonHandler = (addon) => {
        const { addonList } = this.state;
        const add = addonList.filter((items) => items.partNumber !== addon.partNumber);
        this.setState({ addonList: add });
    }

    render() {
        const {
            classes,
            pageData,
            brand,
            product,
            skuData,
            handleAddonChange,
            product: {
                brandId,
                partNumber,
            },
            categoryId,
            subscription,
            subscriptionDetails,
            presentation_family,
            disableAddToCart,
            isAddToCartEnabled,
            categoryPath,
            categoryName,
            selectedSku,
            productSkus,
            updateWineStatus,
            deliveryData,
            handleMiniCartModalClick,
            mobileAgeVerificationOpen,
            handleMobileAgeVerification,
            addToCartData,
        } = this.props;
        const { openModal } = this.state;
        if (!pageData?.findContent?.content?.entries?.[0]) {
            return null;
        }
        const copy = pageData.findContent.content.entries[0].copy;
        const heading = pageData.findContent.content.entries[0].heading;
        const image = pageData.findContent.content.entries[0].images;
        const cardDescription = image?.length > 0 ? classes.cardDesc : classes.cardDetail;
        let imageDisplayCount;
        if (image.length === 1) {
            imageDisplayCount = classes.imageMobileSingle;
        } else if (image.length === 2) {
            imageDisplayCount = classes.imageMobileDouble;
        } else {
            imageDisplayCount = classes.imageMobile;
        }

        return (
            <div>
                <Card className={classes.card}>
                    <Media
                        query="(max-width: 600px)"
                    >
                        {(matches) => (
                            matches ? (
                                <CardContent className={classes.cardContent}>
                                    <div
                                        className={classes.mobileAddonBox}
                                        onClick={this.openModal}
                                        onKeyDown={() => { }}
                                        role="button"
                                        tabIndex={-1}
                                    >
                                        <Grid container alignItems="center" justify="space-between">
                                            <Grid item xs={4} className={classes.mobileImage}>
                                                {image?.map((img) => (
                                                    <img key={img.title} className={imageDisplayCount} src={img.url} alt={img.title} />
                                                ))}
                                            </Grid>
                                            <Grid item xs={8} className={classes.middle}>
                                                <div className={classes.mobileDesc}>
                                                    <div className={classes.cardHeadingMobile}>{heading}</div>
                                                    <p className={classes.cardInfoMobile}>{copy}</p>
                                                </div>
                                                <div className={classes.mobileDescArrow}>
                                                    <ArrowForwardIosIcon fontSize="small" />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </CardContent>
                            ) : (
                                <CardContent className={classes.cardContent}>

                                    {image?.map((img) => (
                                        <div key={img.title} className={classes.imageContainer}>
                                            <img className={classes.image} src={img.url} alt={img.title} />
                                        </div>
                                    ))}
                                    <div className={cardDescription}>
                                        <div className={classes.cardHeading}>{heading}</div>
                                        <p className={classes.cardInfo}>{copy}</p>
                                    </div>
                                    <div
                                        className={classes.options}
                                        onClick={this.openModal}
                                        onKeyDown={() => { }}
                                        role="button"
                                        tabIndex={-1}
                                    >
                                        VIEW OPTIONS
                                    </div>
                                </CardContent>
                            )
                        )}
                    </Media>
                </Card>
                {openModal
                    && (
                        <GraphqlModal
                            brand={brand}
                            handleAddonChange={handleAddonChange}
                            product={product}
                            skuData={skuData}
                            typeModal="Addons"
                            titleModal="ADD SOMETHING SPECIAL"
                            onCloseModal={this.closeModal}
                            brandId={brandId}
                            partNumber={partNumber}
                            categoryId={categoryId}
                            subscription={subscription}
                            subscriptionDetails={subscriptionDetails}
                            presentation_family={presentation_family}
                            disableAddToCart={disableAddToCart}
                            isAddToCartEnabled={isAddToCartEnabled}
                            categoryPath={categoryPath}
                            categoryName={categoryName}
                            selectedSku={selectedSku}
                            productSkus={productSkus}
                            updateWineStatus={updateWineStatus}
                            deliveryData={deliveryData}
                            handleMiniCartModalClick={handleMiniCartModalClick}
                            mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                            handleMobileAgeVerification={handleMobileAgeVerification}
                            addToCartData={addToCartData}
                        />
                    )}
            </div>
        );
    }
}
GraphqlAddon.propTypes = {
    classes: object.isRequired,
    handleMiniCartModalClick: func.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    product: shape({
        id: string.isRequired,
        name: string.isRequired,
        brandId: string.isRequired,
        partNumber: string.isRequired,
    }).isRequired,
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ).isRequired,
        }),
    ).isRequired,
    pageData: shape({
        findContent: shape({
            content: shape({
                entries: arrayOf(shape({
                    copy: string.isRequired,
                    heading: string.isRequired,
                    url: string,
                })),
            }),
        }),
    }).isRequired,
    selectedSku: shape({
        id: string.isRequired,
        minAge: string.isRequired,
    }).isRequired,
    productSkus: arrayOf(shape({
        minAge: string.isRequired,
    })).isRequired,
    handleAddonChange: func.isRequired,

    categoryId: string.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    presentation_family: string.isRequired,
    disableAddToCart: bool,
    isAddToCartEnabled: bool,
    categoryPath: string.isRequired,
    categoryName: string.isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string,
                value: string,
            }),
        ),
        show: bool,
        title: string,
        zip_code_title: string,
        location_type_title: string,
    }).isRequired,
    updateWineStatus: func.isRequired,
    mobileAgeVerificationOpen: bool,
    handleMobileAgeVerification: func,
    addToCartData: addToCartDataType,
};

GraphqlAddon.defaultProps = {
    isAddToCartEnabled: true,
    subscriptionDetails: {},
    disableAddToCart: false,
    subscription: {},
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: () => { },
    addToCartData: {},

};

export default (withStyles(styles)(GraphqlAddon));
